import { Pagination } from '../../../model/paginatiion';
import { IPublicationResponse } from '../../../model/base/response/publication-response';
import { ICategoryPublicationResponse } from '../../../model/base/response/category-publication-response';
import { ISubcategoryPublicationResponse } from '../../../model/base/response/subcategory-publication-response';

export type PublicationsState = {
    publications: Pagination<IPublicationResponse>;
    categories: ICategoryPublicationResponse[];
    subcategories: ISubcategoryPublicationResponse[];
    loading: boolean;
    loadingFilters: boolean;
};

export enum ACTION_TYPES {
    setPublications = 'setPublications',
    setCategories = 'setCategories',
    setSubcategories = 'setSubcategories',
    setLoading = 'setLoading',
    setLoadingFilters = 'setLoadingFilters',
}

export const PublicationsReducer = (state: PublicationsState, action: any): PublicationsState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setPublications:
            return {
                ...state,
                publications: payload,
                loading: false,
            };
        case ACTION_TYPES.setCategories:
            return {
                ...state,
                categories: payload,
                loadingFilters: false,
            };
        case ACTION_TYPES.setSubcategories:
            return {
                ...state,
                subcategories: payload,
            };
        case ACTION_TYPES.setLoading:
            return {
                ...state,
                loading: payload,
            };
        case ACTION_TYPES.setLoadingFilters:
            return {
                ...state,
                loadingFilters: payload,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
